import OxxoPaymentInfo from './OxxoPaymentInfoContainer';

export default OxxoPaymentInfo;
